import axios from 'axios';

// Detect environment and adjust API URL accordingly
const getApiBaseUrl = () => {
  const envUrl = process.env.REACT_APP_API_URL;
  
  // If environment URL is set, use it
  if (envUrl) {
    return envUrl;
  }

  // Use UrbanPOS API for all environments (development and production)
  return "https://api.urbanpos.com/api";
};

const API_BASE_URL = getApiBaseUrl();

const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Add token to requests
api.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export const dashboardService = {
    // Get restaurant summary data
    getSummary: async () => {
        try {
            const response = await api.get('/dashboard/summary');
            return response.data;
        } catch (error) {
            console.error('Error fetching dashboard summary:', error);
            throw error;
        }
    }
};

export default api;
